export const TD_VENDOR_STR = 'TD';
export const DEFAULT_MIN_STRING_LENGTH = 1;
export const FIRST_NAME_MAX_LENGTH = 50;
export const LAST_NAME_MAX_LENGTH = 50;
export const ENTITY_ID_MAX_LENGTH = 100;
export const TD_FIELD_MAX_LENGTH = 50;
export const TD_NATIONAL_PHONE_LENGTH = 16;
export const TD_COUNTRY_CODE_LENGTH = 5;
